export default "__VITE_ASSET__DGcPPY2s__"